import React from "react";
import { Button } from "carbon-components-react";
import { Undo24 } from "@carbon/icons-react";

const styles = require("./RevertDocValue.module.scss");

interface Props {
  oldValue: string;
  revert: Function;
}

const RevertDocValue: React.FC<Props> = ({ oldValue, revert }: Props) => (
  <div className={styles.revertDocValue}>
    <div className={styles.innerContainer}>
      <Button
        className={styles.button}
        kind="ghost"
        size="sm"
        disabled={oldValue === ""}
        onClick={() => revert()}
        renderIcon={Undo24}
      >
        {oldValue === "" ? (
          <span>Nothing to revert to.</span>
        ) : (
          <span>
            Revert to <span style={{ fontWeight: "bold" }}>{oldValue}</span>
          </span>
        )}
      </Button>
    </div>
  </div>
);

export default RevertDocValue;
